<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>加值服務方案
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>加值服務方案</h1>
        <p class="my-3">&nbsp;</p>
        <div class="left">
          <table width="100%" class="tableDisplay">
            <tr>
              <th width="30%" class="text-left">服務內容</th>
              <th width="30%" class="text-center">付費</th>
              <th width="20%" class="text-center">免費</th>
              <th width="20%" class="text-center" nowrap>示意圖</th>
            </tr>
            <tr>
              <td nowrap>1. 參展商基本資訊</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center">
                <a :href="fancyboxImg1" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>2. 參展商產品發布</td>
              <td align="center"><span name="Exh_ProductAmount_vip"></span> 項</td>
              <td align="center"><span name="Exh_ProductAmount"></span> 項</td>
              <td align="center">
                <a :href="fancyboxImg2" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>

            <tr>
              <td nowrap>3. 參展商新聞稿發布</td>
              <td align="center"><span name="Exh_NewsAmount_vip"></span> 則</td>
              <td align="center"><span name="Exh_NewsAmount"></span> 則</td>
              <td align="center">
                <a :href="fancyboxImg3" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>4. 參展商影音發布</td>
              <td align="center"><span name="Exh_VideoAmount_vip"></span> 則</td>
              <td align="center"><span name="Exh_VideoAmount"></span> 則</td>
              <td align="center">
                <a :href="fancyboxImg8" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>
            <tr>
              <td>5. 接收產品詢問函</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center">
                <a :href="fancyboxImg5" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>6. 專屬平面圖</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="red bold">x</span></td>
              <td align="center">
                <a :href="fancyboxImg6" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>
            <tr>
              <td>7. 展前快訊EDM</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="red bold">x</span></td>
              <td align="center">
                <a :href="fancyboxImg7" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>
            <tr>
              <td>8. 站內搜尋優先排序</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="red bold">x</span></td>
              <td align="center">
                <a :href="fancyboxImg9" data-fancybox="images"><img src="@/assets/images/view.png" /></a>
              </td>
            </tr>

            <tr class="bold">
              <th class="text-left">服務價格</th>
              <th class="text-center">NT$ 5,250 (含稅)</th>
              <th class="text-center">免費</th>
              <th class="text-center">&nbsp;</th>
            </tr>
          </table>
          <p class="my-3">&nbsp;</p>
          <p class="italic">服務期間：即日起 ~ 展後 2個月</p>
        </div>
        <div class="right">
          <h3>負責業務</h3>
          <p class="my-3">&nbsp;</p>
          <div name="ExpoContact"></div>
        </div>
        <p class="clear"></p>
      </div>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    components: {},

    metaInfo() {
      return {
        title: '加值服務方案 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        fancyboxImg2: require('@/assets/images/upgrade/01產品發佈.jpg'),
        fancyboxImg1: require('@/assets/images/upgrade/02基本資訊.jpg'),
        fancyboxImg3: require('@/assets/images/upgrade/03新聞稿.jpg'),
        fancyboxImg5: require('@/assets/images/upgrade/04產品詢問函.jpg'),
        fancyboxImg6: require('@/assets/images/upgrade/05平面圖.jpg'),
        fancyboxImg7: require('@/assets/images/upgrade/06展前快訊.jpg'),
        fancyboxImg9: require('@/assets/images/upgrade/07關鍵字.jpg'),
        fancyboxImg8: require('@/assets/images/upgrade/08影音.jpg'),

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    methods: {},

    created() {
      const vm = this

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let nowPage = location.href
      let RegNo = nowPage.split('no=')[1]

      let lang = 'tw'

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${RegNo}?lang=${lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      $.getJSON(
        '/apiExhibitors/AdvContact/' + RegNo,
        {
          lang: lang,
        },
        function (data) {
          $('[name="ExpoContact"]').html(data.Data.AdvContact)
        }
      )

      //方案數量
      $.getJSON('/apiExhibitors/Exhibition/' + RegNo, { lang: lang }, function (data) {
        // console.log(data)
        $('[name="Exh_ProductAmount"]').text(data.Data.Exh_ProductAmount)
        $('[name="Exh_ProductAmount_vip"]').text(data.Data.Exh_ProductAmount_vip)
        $('[name="Exh_NewsAmount"]').text(data.Data.Exh_NewsAmount)
        $('[name="Exh_NewsAmount_vip"]').text(data.Data.Exh_NewsAmount_vip)
        $('[name="Exh_VideoAmount"]').text(data.Data.Exh_VideoAmount)
        $('[name="Exh_VideoAmount_vip"]').text(data.Data.Exh_VideoAmount_vip)
      })
    },
  }
</script>

<style lang="scss">
  @import './../../assets/helper/table.css';
  @import './../../assets/helper/fancybox.css';
</style>
